import script from "./FilterPills.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterPills.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__